import { useCMSYAUTHstore } from '@/service/stores/cm/cmsy/AUTH.store'
import { LOGIN_PAGE } from './constants.guard'
import { doApplInitLogin } from '@/utils/applInit'

// 앱 최초 진입 시 한 번만 실행되는 가드
export function createInitialGuard(router) {
  const removeGuard = router.beforeEach(async (to) => {
    removeGuard()
    return execGuard(to)
  })
}

/** 가드 실행 */
const execGuard = async (to) => {
  const CMSYAUTHstore = useCMSYAUTHstore()

  if (to.name === 'AUTH-CALLBACK') {
    return
  }

  const redirectRoute = (routeName) => (to.name === routeName ? true : { name: routeName })

  const logoutAndRedirect = () => {
    gsconsole.warn('저장된 사용자 계정이 useYn = N으로 확인되어 로그아웃 처리됩니다.')
    CMSYAUTHstore.actionLogout()
    return redirectRoute(LOGIN_PAGE)
  }

  if (CMSYAUTHstore?.$persistedState?.isReady) {
    await CMSYAUTHstore.$persistedState.isReady()
  }

  if (!CMSYAUTHstore.getIsLoggedIn) {
    CMSYAUTHstore.actionLoadAuth()
  }

  if (CMSYAUTHstore.getIsLoggedIn) {
    const isApplInitSuccess = await doApplInitLogin({ isShowErr: false })
    if (!isApplInitSuccess) {
      return logoutAndRedirect()
    }
  }
}
